import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const showSmnCaPpageBannerSelector = createSelector(testTargetOffersSelector, offers => offers?.SmnCaPpageBanner || Empty.Object);

export { showSmnCaPpageBannerSelector };
